import { Navigate } from "react-router-dom";

function decodeRoleFromToken(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.role || null;
  } catch (_) {
    return null;
  }
}

export default function AdminRoute({ children }) {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");
  let user = null;
  if (userRaw) {
    try {
      user = JSON.parse(userRaw);
    } catch (_) {
      user = null;
    }
  }

  if (!token) return <Navigate to="/login" replace />;
  const role = user?.role || decodeRoleFromToken(token);
  if (role !== "admin") return <Navigate to="/login" replace />;

  return children;
}
